/* eslint-disable @typescript-eslint/no-explicit-any */
import { TripBookShippingDiscount } from '51trips-frontend-core'

const tripBookShippingDiscountConverter = {
  fromFirestore: (data: any) => {
    if (data) {
      let countryNumericCode: string | undefined
      if (typeof data.countryNumericCode === 'string') {
        countryNumericCode = data.countryNumericCode
      }

      let discount: number | undefined
      if (typeof data.discount === 'number') {
        discount = data.discount
      }

      let currency: string | undefined
      if (typeof data.currency === 'string') {
        currency = data.currency
      }

      let isAvailable: boolean = false
      if (typeof data.isAvailable === 'string') {
        isAvailable = data.isAvailable
      }

      return new TripBookShippingDiscount(countryNumericCode, discount, currency, isAvailable)
    } else {
      return undefined
    }
  }
}

export default tripBookShippingDiscountConverter
